import { useGlobalContext } from '~/context/GlobalContext';
import { useState, useEffect, useRef } from 'react';
import styles from './Search.module.css';

function Search() {
  const { setContext } = useGlobalContext();
  const [tempValue, setTempValue] = useState('');
  
  const setContextRef = useRef(setContext);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    setTempValue(val);

    // Wysyłamy do kontekstu (bez spacji na końcach)
    const query = val.toLowerCase().trim();
    setContext({ searchQuery: query });
  };

  // Efekt czyszczenia – zadziała TYLKO przy zamknięciu komponentu
  useEffect(() => {
    return () => {
      // Używamy referencji, aby React nie krzyczał o zależnościach
      setContextRef.current({ searchQuery: '' });
    };
  }, []);

  return (
    <div data-component="Search" className={styles.search}>
      <input
        ref={inputRef}
        className={styles.searchInput}
        type="search"
        placeholder="Szukaj..."
        autoComplete="off"
        value={tempValue}
        onChange={handleSearch}
        /* --- ZABEZPIECZENIE PRZED AUTO-FOCUSEM NA MOBILE --- */
        readOnly
        onTouchStart={(e) => {
          const input = inputRef.current;
          if (!input) return;
          
          // Zdejmujemy blokadę tylko przy interakcji użytkownika
          input.readOnly = false;
          
          setTimeout(() => {
            input.focus();
          }, 50);
        }}
        onBlur={() => {
          // Przywracamy readOnly, aby przy ponownym otwarciu klawiatura znów nie wyskoczyła sama
          if (inputRef.current) {
            inputRef.current.readOnly = true;
          }
        }}
      />
    </div>
  );
};

export default Search;